import { render, staticRenderFns } from "./VideoDownloader.vue?vue&type=template&id=4def6a89&scoped=true&"
import script from "./VideoDownloader.vue?vue&type=script&lang=js&"
export * from "./VideoDownloader.vue?vue&type=script&lang=js&"
import style0 from "./VideoDownloader.vue?vue&type=style&index=0&id=4def6a89&prod&scoped=true&lang=css&"
import style1 from "./VideoDownloader.vue?vue&type=style&index=1&id=4def6a89&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4def6a89",
  null
  
)

export default component.exports